import React, { useState, useEffect, useContext } from "react"
import {
  Main,
  Header,
  useGlobalAudio,
} from "@orbital/games-frontend-library"
import { AstroWrapper } from "./AstroStyles"
import PreLaunch from "./board/preLaunch/PreLaunch"
import Footer from "./board/footer/Footer"
import { detectState } from "./helpers"
import { MyContext } from "../context/createContext"

export default function Game({
  blur,
  colors,
  handleAbove,
  round,
  users,
  handleNotification,
  isError,
  audio,
  placedBet,
  handleBetOnExplosion,
  setbetSend,
  betError,
  notification,
}: // astroSocketMessages,
any) {
  const { ctx } = useContext(MyContext)
  const { auth, config } = ctx
  const { amount } = auth.balance
  const SFXS = useGlobalAudio(audio.volume, audio.sound)

  const [roundState, setroundState] = useState("COUNTER")
  useEffect(() => {
    detectState(round.state, setroundState)
  }, [round.state])

  const [preLaunchState, setpreLaunchState] = useState(false)
  useEffect(() => {
    setpreLaunchState(roundState === "PLAY" || roundState === "COUNTER")
  }, [roundState])

  return (
    <Main blur={blur}>
      <AstroWrapper>
        <Header
          title="Astro"
          gameInfo={{
            balance: amount,
            precision: config.prec,
            currency: auth.currency_id,
          }}
          colors={colors}
          handleAbove={handleAbove}
          sfx={SFXS.goForwardSFX}
          betInfoBalance={amount}
          balanceUpdateOn="now"
          fontSize={"20px"}
        />
        {preLaunchState && <PreLaunch start={round.starttimer} duration={8} />}
        <Footer
          handleAbove={handleAbove}
          users={users}
          round={round}
          handleNotification={handleNotification}
          isError={isError}
          roundState={roundState}
          audio={audio}
          balance={amount}
          placedBet={placedBet}
          handleBetOnExplosion={handleBetOnExplosion}
          setbetSend={setbetSend}
          betError={betError}
          notification={notification}
          // astroSocketMessages={astroSocketMessages}
        />
      </AstroWrapper>
    </Main>
  )
}
